export default __webpack_public_path__ + "static/media/waave_business_green_white.85d84dc4.png";